export const privacyPolicyData = {
  title: "Privacy Policy",
  sections: [
    {
      title: "Data Collection",
      description:
        "Darayish only asks for the user's email address, and then asks the user to enter the names of their children.",
    },
    {
      title: "Data Use",
      description:
        "The information collected by Darayish is used to personalize user experiences and to provide notifications and notices. User data is securely stored and used only to enhance the functionality of the platform and user engagement.",
    },
    {
      title: "Data Security",
      description:
        "Darayish uses security measures to protect user data against unauthorized access, alteration, disclosure, or destruction. Encryption protocols and secure servers are used to ensure the confidentiality and integrity of user information.",
    },
    {
      title: "Data Sharing",
      description:
        "User information is not shared or sold to third parties for marketing or commercial purposes. However, data may be shared with trusted partners or service providers to improve the performance of the platform or as required by law.",
    },
    {
      title: "User Rights",
      description:
        "Users have the right to access the conversations with their children stored on the Darayish application. They may also opt out of certain data collection practices, although this may impact the functionality of some features.",
    },
    {
      title: "Cookies and Tracking",
      description:
        "Darayish uses cookies and similar tracking technologies to enhance user experiences and analyze platform usage. Users have the option to manage their cookie preferences through their browser settings.",
    },
    {
      title: "Third-Party Links",
      description:
        "Darayish does not contain links to external websites or third-party services.",
    },
    {
      title: "Children’s Privacy",
      description:
        "Darayish is intended for users under the age of 13. We do not collect or store personal information from children without parental consent. If you believe that a child has provided us with personal information, please contact us immediately so that we can take appropriate action.",
    },
    {
      title: "Data Retention",
      description:
        "User data is retained for as long as necessary to fulfill the purposes outlined in this Privacy Policy or as required by law. Users may request deletion of their data in accordance with applicable regulations.",
    },
    {
      title: "Changes to Privacy Policy",
      description:
        "Darayish reserves the right to update or modify this Privacy Policy periodically. Users will be notified of any significant changes and continued use of the Platform after such modifications constitutes acceptance of the revised Privacy Policy.",
    },
    {
      title: "Contact Information",
      description:
        "If you have any questions or comments about this Privacy Policy, the ways in which we collect and use your personal data, and your choices and rights in relation to such use, please feel free to contact us at:\n+966 565935735\nHello@darayish.net\nKingdom of Saudi Arabia, Eastern Province, Khobar City, Dos Tower",
    },
  ],
};
